import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const fullHunt = defineConnector({
  identifier: "fullHunt",
  name: "FullHunt",
  tagLine: "External attack surface discovery",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://fullhunt\\.io/api/.*",
  auth: (app) => headerAuth([{ name: "X-API-KEY", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log into [FullHunt](https://fullhunt.io/) and create an API key from your account settings.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "FullHunt API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://fullhunt.io/api/v1/auth/status",
  },
});
